import getLocalString from "constants/Localization";
import { useUpdateDailyFormInspectionMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateDailyFormInspection() {
  const [mutation, { loading, data, error }] = useUpdateDailyFormInspectionMutation({
    refetchQueries: ["getDailyFormInspections"],
  });

  const [updateDailyFormInspection, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateDailyFormInspection",
    },
    {
      successMessage: getLocalString("fleet.update-inspection-success"),
      failureMessage: getLocalString("fleet.update-inspection-failure"),
    }
  );

  return [updateDailyFormInspection, context] as const;
}
